import { CircularProgress, Backdrop } from '@mui/material';
import React, { forwardRef } from 'react';

const BSSForm = ({onEnterSubmit = false, methods = {}, ...props}) => {

    const checkKeyDown = e => {
        const keyCode = e.keyCode ? e.keyCode : e.which; 
        if (keyCode === 13 && !onEnterSubmit) { 
            e.preventDefault() 
        };
    }

    const {formState = {}} = methods;
    const {isSubmitting = null} = formState;

    return (
        <>
            <form onKeyDown={checkKeyDown} {...props}>
                {props.children}
            </form>

            <Backdrop
                open={isSubmitting === true}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    )
}

export default BSSForm;